const translations = {
  en: {
    title: 'Scheduled visits guide',
    summary:
      'Open the full PDF guide for the scheduled visits flow directly '
      + 'from the Help Center.',
    category: 'Visit schedule',
    tags: ['Visits', 'PDF', 'Guide'] as string[],
    openPdfLabel: 'Open PDF in new tab',
    downloadPdfLabel: 'Download PDF',
    documentFrameTitle: 'Scheduled visits PDF guide',
    fallbackLabel: 'Tip',
    fallbackText:
      'If your browser blocks PDF preview inside the app, use the '
      + 'button above to open the file in a new tab.',
  },
  pt: {
    title: 'Guia de visitas agendadas',
    summary:
      'Abra o PDF completo do fluxo de visitas agendadas direto pela '
      + 'Central de Ajuda.',
    category: 'Agendamento de visitas',
    tags: ['Visitas', 'PDF', 'Guia'] as string[],
    openPdfLabel: 'Abrir PDF em nova aba',
    downloadPdfLabel: 'Baixar PDF',
    documentFrameTitle: 'Guia em PDF de visitas agendadas',
    fallbackLabel: 'Dica',
    fallbackText:
      'Se o navegador bloquear a visualização do PDF dentro do sistema, '
      + 'use o botão acima para abrir o arquivo em outra aba.',
  },
};

export default translations;
